import React, { Component } from 'react';
import { connect } from 'react-redux';
import { authStatus } from '../actions/authActions';
import { getPlayerId, setPlayerId } from '../utils/playerId';

const fetch = require("node-fetch");

class AccountModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mode: props.initialMode || 'login', // 'login' | 'register'
      email: '',
      password: '',
      status: 'idle',
      error_message: '',
    };
    this.handle_submit = this.handle_submit.bind(this);
    this.handle_key_down = this.handle_key_down.bind(this);
    this.toggle_mode = this.toggle_mode.bind(this);
  }

  componentDidMount() {
    document.addEventListener('keydown', this.handle_key_down);
    if (this.email_input) {
      this.email_input.focus();
    }
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handle_key_down);
  }

  handle_key_down(event) {
    if (event.key === 'Escape') {
      this.props.onClose();
    }
  }

  handle_change(field) {
    return (event) => this.setState({ [field]: event.target.value });
  }

  toggle_mode() {
    this.setState({
      mode: this.state.mode === 'login' ? 'register' : 'login',
      status: 'idle',
      error_message: '',
    });
  }

  async handle_submit(event) {
    event.preventDefault();
    this.setState({ status: 'sending', error_message: '' });
    const url = this.state.mode === 'login' ? '/api/login' : '/api/register';
    try {
      const response = await fetch(url, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: this.state.email,
          password: this.state.password,
          player: getPlayerId(),
        }),
      });
      const json = await response.json();
      if (!response.ok) {
        this.setState({ status: 'error', error_message: json.error || 'Something went wrong' });
        return;
      }
      if (json.player && json.player.uuid) {
        setPlayerId(json.player.uuid);
      }
      this.props.dispatch(authStatus(true, json.email));
      this.props.onClose();
    } catch (error) {
      this.setState({ status: 'error', error_message: 'Could not reach the server' });
    }
  }

  render() {
    const is_login = this.state.mode === 'login';
    return (
      <div
        id="account_modal_overlay"
        onClick={(event) => { if (event.target === event.currentTarget) this.props.onClose(); }}
      >
        <div role="dialog" aria-modal="true" aria-labelledby="account_modal_title" id="account_modal">
          <h2 id="account_modal_title">{is_login ? 'Log in' : 'Create an account'}</h2>
          <button
            id="account_modal_close"
            type="button"
            aria-label="Close"
            onClick={() => this.props.onClose()}
          >×</button>
          <form onSubmit={this.handle_submit}>
            <label htmlFor="account_email_input">Email</label>
            <input
              id="account_email_input"
              type="email"
              required
              autoComplete="email"
              placeholder="you@example.com"
              value={this.state.email}
              onChange={this.handle_change('email')}
              ref={ref => this.email_input = ref}
            />
            <label htmlFor="account_password_input">Password</label>
            <input
              id="account_password_input"
              type="password"
              required
              minLength={8}
              autoComplete={is_login ? 'current-password' : 'new-password'}
              placeholder="At least 8 characters"
              value={this.state.password}
              onChange={this.handle_change('password')}
            />
            <button id="account_submit" type="submit" disabled={this.state.status === 'sending'}>
              {this.state.status === 'sending' ? 'Please wait…' : (is_login ? 'Log in' : 'Sign up')}
            </button>
            {this.state.status === 'error' && (
              <p id="account_modal_error" role="alert">{this.state.error_message}</p>
            )}
          </form>
          {is_login ? (
            <button id="account_register_button" type="button" onClick={this.toggle_mode}>
              Register
            </button>
          ) : (
            <button id="account_modal_toggle" type="button" onClick={this.toggle_mode}>
              Already have an account? Log in
            </button>
          )}
        </div>
      </div>
    );
  }
}

export default connect()(AccountModal);
